<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">XigCheck Terms of Service</h1>
        <p class="desc-text">Effective Date: August 5, 2025</p>

        <section class="content-section">
            <p class="desc-text">XigCheck is an independent product review and marketplace trust support layer affiliated with the XigFor marketplace platform.</p>
            <p class="desc-text">By using XigCheck services, you agree to the following terms.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">1. Scope of Services</h2>
            <p class="desc-text">XigCheck offers optional authentication review services for certain high-value pre-owned goods categories, including but not limited to:</p>
            <ul class="policy-list">
                <li>Luxury Handbags</li>
                <li>Luxury Accessories</li>
                <li>High-End Sneakers</li>
            </ul>
            <p class="desc-text">Authentication services are limited to product authenticity verification and market trust support.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">2. Independent Authentication Review</h2>
            <p class="desc-text">Authentication services may include:</p>
            <ul class="policy-list">
                <li>AI-Assisted Review</li>
                <li>Expert-Assisted Review</li>
                <li>Visual Inspection</li>
                <li>Independent Third-Party review support</li>
            </ul>
            <p class="desc-text">Some authentication reviews may be supported by independent third-party authentication providers under separate service agreements.</p>
            <p class="desc-text">Authentication results represent independent review opinions only and do not constitute any financial guarantee.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">3. No Financial Services Provided</h2>
            <p class="desc-text">XigCheck does not provide the following services:</p>
            <ul class="policy-list">
                <li>Escrow Services</li>
                <li>Transaction Guarantees</li>
                <li>Insurance Services</li>
                <li>Custodial Financial Services</li>
                <li>Financial Protection Services</li>
            </ul>
            <p class="desc-text">All payments are processed directly through approved third-party payment service providers (such as PayPal or Stripe).</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">4. No Financial Guarantee of Authentication Outcomes</h2>
            <p class="desc-text">Authentication reviews are independent assessments based on the information available at the time of evaluation and the review methods used.</p>
            <p class="desc-text">XigCheck does not provide financial guarantees, insurance coverage, resale guarantees, or warranties regarding future product condition, resale value, or merchant conduct.</p>
            <p class="desc-text">XigCheck makes no financial guarantees or warranties regarding the future condition, resale value, or merchant conduct of products.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">5. User Responsibility</h2>
            <p class="desc-text">Users are responsible for:</p>
            <ul class="policy-list">
                <li>Providing accurate product information</li>
                <li>Complying with platform policies</li>
            </ul>
            <p class="desc-text">Submitting false information or engaging in fraudulent activities may result in:</p>
            <ul class="policy-list">
                <li>Authentication review rejection</li>
                <li>Account restriction or removal</li>
                <li>Suspension of platform services</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">6. Limitation of Liability</h2>
            <p class="desc-text">Product review assessments are conducted based on reasonable commercial efforts.</p>
            <p class="desc-text">XigCheck neither guarantees nor assumes liability for the following:</p>
            <ul class="policy-list">
                <li>Future resale value</li>
                <li>Product condition</li>
                <li>Investment value</li>
                <li>Indirect losses</li>
                <li>Resale disputes</li>
                <li>Market pricing outcomes</li>
                <li>User-to-user transaction disputes</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">7. Policy Updates</h2>
            <p class="desc-text">XigCheck may periodically update these Terms to reflect operational, legal, or compliance requirements.</p>
            <p class="desc-text">Continuing to use XigCheck services constitutes your acceptance of the updated Terms.</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckTermsOfService'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
